import React from 'react';
import './about.css';
import ME from '../../assets/aboutCover2.jpg'
import {FaAward} from 'react-icons/fa'
import {VscFolderActive} from 'react-icons/vsc'

const About = () => {
  return (
    <section id='about'>

      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">

        <div className="about__me">
          <div className="about__me__image">
            <img src={ME} alt="Can't Load Properly!" />
          </div>
        </div>

        <div className="about__content">

          <div className="about__cards">

            <article className="about__card">
              <FaAward className='about__icon' />
              <h5>Experience</h5>
              <small>Fresher :)</small>
            </article>

            <article className="about__card">
              <VscFolderActive className='about__icon' />
              <h5>Projects</h5>
              <small>3 Complete Realtime Projects</small>
            </article>
          </div>

          <p>A Tech Enthusiasist, wants to explore more in my field and work to grow myself. Looking for opportunities like internships to learn.
            Interest in fields like Web-Development, Android/IOS Development, MERN Stack etc.
          </p>

          <a href="#contact" className='btn btn-primary' style={{fontFamily: 'Poppins, sans-serif', fontSize: 'large', fontWeight: 600}}>Let's Talk</a>
        </div>

      </div>
    </section>
  )
}

export default About;